// @flow
import {call} from 'redux-saga/effects'
import callLogin from '$api/login'
import {setTokensState} from '$util'

export default function* login(credentials: {
  email: string,
  password: string
}): Generator<> {
  const tokens = yield call(callLogin, credentials)
  yield call(setTokensState, {...tokens, email: credentials.email})
}



// WEBPACK FOOTER //
// ./src/auth/sagas/login.js